import script from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=4cc93bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc93bd8"]])

export default __exports__